import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FC } from 'react';
import { SCUIButton, SCUIDateRanger } from '../../../atomic/atoms';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { ExpenseNoteFilterModel, initialEmpty } from '../ExpenseNote.helper';
import { EXPNOTEFILTER } from '../expenseNote.classes';

interface IProps {
    onClose?: () => void;
    getExpenseNote?: (req: any) => void;
    filterModels: ExpenseNoteFilterModel;
}

export const ExpenseNoteFilterDrawer: FC<IProps> = ({ onClose, getExpenseNote, filterModels }) => {
    const { t } = useTranslation();
    const clearForm = () => {
        filterModels.setOrderNo(initialEmpty.orderNo);
        filterModels.setShipmentNo(initialEmpty.shipmentNo);
        filterModels.setCompassNo(initialEmpty.compassNo);
        filterModels.setStartDate(initialEmpty.startDate);
        filterModels.setEndDate(initialEmpty.endDate);
        filterModels.setStatus(initialEmpty.status);
    };
    const handleOnClicked = () => {
        let req: any = {
            orderNo: filterModels.orderNo,
            shipmentNo: filterModels.shipmentNo,
            compassNo: filterModels.compassNo,
            startDate: filterModels.startDate
                ? moment(filterModels.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
                : null,
            endDate: filterModels.endDate ? moment(filterModels.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null,
            status: filterModels.status,
        };
        getExpenseNote?.(req);
        onClose?.();
    };
    const _handlChangeDate = (event: any) => {
        filterModels.setStartDate(event[0]);
        filterModels.setEndDate(event[1]);
    };

    return (
        <div className={EXPNOTEFILTER.root} style={{ padding: '0 16px' }}>
            <Grid container
                className={EXPNOTEFILTER.headerRow}
                alignItems="center"
                justifyContent="space-between"
                sx={{ paddingTop: 2, borderBottom: "1px solid #e0e0e0" }}
            >
                <Grid>
                    <h4 className={EXPNOTEFILTER.title} style={{ margin: 0, fontSize: '18px', fontWeight: 1000 }}>Detaylı Arama</h4>
                </Grid>
                <Grid>
                    <CloseIcon className={`cursorPointer ${EXPNOTEFILTER.closeTrigger}`} style={{ fontSize: '20px' }} onClick={onClose} />
                </Grid>
            </Grid>
            <Grid
                className={EXPNOTEFILTER.dateRangeWrap}
                sx={{ marginTop: 2, marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
                 <FormControl fullWidth>
                     <SCUIDateRanger
                         size="small"
                         setDateRange={_handlChangeDate}
                         dateFormat="DD-MM-YYYY"
                         fromDate={filterModels?.startDate}
                         toDate={filterModels?.endDate}
                     />
                 </FormControl>
             </Grid>
            <Grid
                sx={{ marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
                <TextField
                    className={EXPNOTEFILTER.inputTextfieldOrderNo}
                    fullWidth
                    label={t('general.orderNo')}
                    value={filterModels?.orderNo}
                    onChange={(e: any) => filterModels.setOrderNo(e.target.value)}
                />
            </Grid>
            <Grid
                sx={{ marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
                <TextField
                    className={EXPNOTEFILTER.inputTextfieldShipmentNo}
                    fullWidth
                    label={t('general.shippingNo')}
                    value={filterModels?.shipmentNo}
                    onChange={(e: any) => filterModels.setShipmentNo(e.target.value)}
                />
            </Grid>
            <Grid
                sx={{ marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
                <TextField
                    className={EXPNOTEFILTER.inputTextfieldCompassNo}
                    fullWidth
                    label="Pusula No"
                    value={filterModels?.compassNo}
                    onChange={(e: any) => filterModels.setCompassNo(e.target.value)}
                />
            </Grid>
            <Grid
                sx={{ marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
                <FormControl className={EXPNOTEFILTER.statusFieldWrap} fullWidth>
                    <InputLabel id="labelApp">{'Statü'}</InputLabel>
                    <Select
                        className={EXPNOTEFILTER.inputSelectStatus}
                        value={filterModels?.status}
                        label="Statü"
                        onChange={(e: any) => filterModels.setStatus(e.target.value)}
                    >
                        <MenuItem value={'true'}>Yazdırıldı</MenuItem>
                        <MenuItem value={'false'}>Yazdırılmayı Bekliyor</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
            <Grid
                className={EXPNOTEFILTER.actionsRow}
                sx={{ marginTop: 3, marginBottom: 2 }}
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }}>
    <Grid container spacing={2}>
        <Grid
            size={{
                xs: 6
            }}>
            <SCUIButton
                className={EXPNOTEFILTER.inputButtonClear}
                text={t('general.clear')}
                type="primary"
                buttonType="button"
                sizeType="fixed"
                style={{ backgroundColor: 'red', borderColor: 'red' }}
                size={"m"}
                onClick={clearForm}
                fullwidth
            />
        </Grid>
        <Grid
            size={{
                xs: 6
            }}>
            <SCUIButton
                className={EXPNOTEFILTER.inputButtonApply}
                text={'Filtrele'}
                type="primary"
                sizeType="fixed"
                buttonType="submit"
                size={"m"}
                onClick={handleOnClicked}
                fullwidth
            />
        </Grid>
    </Grid>
</Grid>
        </div>
    );
};
